export class ItemOperacionCancelada {
    institucion;
    numero_operaciones;
    valor_original;
    forma_cancelacion;
    fecha_cancelacion;
    constructor() {
        this.institucion = "";
        this.numero_operaciones = 0;
        this.valor_original = 0;
        this.forma_cancelacion = "";
        this.fecha_cancelacion = "";
    }
}
